import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
import { isAuthenticated } from '../../helpers/authenticate';
import PropTypes from 'prop-types';
import DialogConfirmacao from '../../components/DialogConfirmacao/DialogConfirmacao';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 150,
    textAlign: 'center'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 400
  }
}));

const ExcecaoView = (props) => {
  const classes = useStyles();
  const { caminhoImagem, titulo, descricao, history } = props;

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  return (
    <div className={classes.root}>
      <Grid
        container
        justify="center"
        spacing={4}
      >
        <Grid
          item
          lg={6}
          xs={12}
        >
          <div className={classes.content}>
            <Typography variant="h2">
              { titulo }
            </Typography>
            <Typography variant="subtitle2">
              { descricao }
            </Typography>
            <img
              alt="Under development"
              className={classes.image}
              src={ caminhoImagem }
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

ExcecaoView.propTypes = {
  titulo: PropTypes.string.isRequired,
  descricao: PropTypes.string.isRequired,
  caminhoImagem: PropTypes.string.isRequired
};

export default ExcecaoView;
